/* eslint-disable */
import * as types from "../../Types/Masters";

interface SalutationDetails {
  name: string;
  code: string;
}
interface GenderMapping {
  salutationDetails: SalutationDetails;
}
interface GenderData {
  code: string;
  genderMappings: GenderMapping[];
}
interface TransformedData {
  [key: string]: { label: string; value: string }[];
}

interface MappingDetails {
  name: string;
  code: string;
}

interface GenderRelMapping {
  relationshipCode: string;
  genderCode: string;
  relationshipDetails: MappingDetails;
}

interface DataItem {
  name: string;
  code: string;
  genderRelMapping: GenderRelMapping[];
}

function convertToKeyValuePair(payload: []) {
  var keyValuePair: any = {};
  if (payload) {
    payload?.forEach((element: any) => {
      keyValuePair[element.code] = element.name;
    });
  }
  return keyValuePair;
}

export const populateRange = (data: Record<string, any>) => {
  let obj: Record<string, any>[] = [];
  const { min, max } = data;
  for (let index = min; index <= max; index += 1) {
    obj?.push({
      label: index,
      value: index
    });
  }
  return obj;
};

const mapRuleEngineData = (data: Record<string, any>) => {
  const obj = Object.entries(data)?.reduce((acc: Record<string, any>, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value.reduce((innerAcc: Record<string, any>, ele: any) => {
        innerAcc[ele?.value] = ele?.label;
        return innerAcc;
      }, {});
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
  return obj;
};

const mapProductData = (productData: Record<string, any>) => {
  var obj: any = {};
  productData?.forEach(({ productId, productName }: any) => {
    obj[productId] = productName;
  });
  return obj;
};

const mapProductPartnerIdData = (
  partnerProductData: { partnerId: string; productId: string }[]
) => {
  return partnerProductData.reduce((acc: Record<string, string[]>, { partnerId, productId }) => {
    if (!acc[partnerId]) {
      acc[partnerId] = [];
    }
    acc[partnerId].push(productId);
    return acc;
  }, {});
};

const convertSalutationGenderData = (data: GenderData[]): TransformedData => {
  let transformedData: TransformedData = {};

  data?.forEach((gender) => {
    transformedData[gender.code] = gender.genderMappings?.map((mapping) => ({
      label: mapping.salutationDetails.name,
      value: mapping.salutationDetails.code
    }));
  });

  return transformedData;
};

const convertRelationshipGenderData = (data: DataItem[]): TransformedData => {
  let transformedData: TransformedData = {};

  data?.forEach((item) => {
    transformedData[item.code] = item.genderRelMapping?.map((mapping) => ({
      label: mapping.relationshipDetails.name,
      value: mapping.relationshipDetails.code
    }));
  });

  return transformedData;
};

const mapQuestionnaire = (data: Record<string, any>[]) => {
  const questionnaireMap = new Map(
    data?.map((q) => [
      q?.questionnaireID,
      { ...q?.Questionnaire?.description, key: q?.questionnaireID }
    ])
  );

  const nestedValues = data?.map((item) => {
    if (item?.Questionnaire?.description?.subQuestions?.questionIDs) {
      item.Questionnaire.description.subQuestions.questions =
        item.Questionnaire?.description?.subQuestions?.questionIDs?.flatMap((id: any) =>
          questionnaireMap?.get(id) ? [questionnaireMap?.get(id)] : []
        );
    }
    return item;
  });

  const finalOutput = nestedValues
    ?.filter((q) => q?.sequenceID)
    ?.reduce((acc, q) => {
      acc[q?.questionnaireID] = {
        sequenceID: q?.sequenceID,
        description: q?.Questionnaire?.description,
        questionnaireID: q?.questionnaireID
      };
      return acc;
    }, {});

  return finalOutput;
};

export const mapRiderMasterData = (rider: Record<string, any>) => {
  const planOptions: Record<string, any> = {};
  const subPlanOptions: Record<string, any> = {};
  const productSelection: Record<string, any> = {};
  const benefitType: Record<string, any> = {};
  const obj = Object.entries(rider)?.reduce((acc: Record<string, any>, [key, value]) => {
    productSelection[key] = key;
    acc[key] = value?.benefitType?.reduce(
      (acc: Record<string, any>, benefit: Record<string, any>) => {
        benefitType[benefit?.value] = benefit?.label;
        acc[benefit?.value] = benefit?.planOptions?.reduce(
          (acc: Record<string, any>, planOption: Record<string, any>) => {
            planOptions[planOption?.value] = planOption?.label;
            acc[planOption?.value] = planOption?.subPlanOption?.reduce(
              (acc: Record<string, any>, subPlan: Record<string, any>) => {
                subPlanOptions[subPlan?.value] = subPlan?.label;
                acc[subPlan?.value] = subPlan?.label || "";
                return acc;
              },
              {}
            );
            return acc;
          },
          {}
        );
        return acc;
      },
      {}
    );
    return acc;
  }, {});
  return { planOptions, subPlanOptions, productSelection, benefitType, masterMapping: obj };
};

const MASTERDATA_REDUCER = (
  // eslint-disable-next-line default-param-last
  state: any = {},
  action: { type: string; payload: any }
) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_GENDER_DETAILS:
      return { ...state, genderDetails: convertToKeyValuePair(payload) };
    case types.SET_EDUCATION_DETAILS:
      return { ...state, educationDetails: convertToKeyValuePair(payload) };
    case types.SET_RELATIONSHIP_DETAILS:
      return { ...state, relationshipDetails: convertRelationshipGenderData(payload) };
    case types.SET_OCCUPATION_DETAILS:
      return { ...state, occupationDetails: convertToKeyValuePair(payload) };
    case types.SET_ASSIGNMENT_OCCUPATION_DETAILS:
      return { ...state, assignmentOccupationDetails: convertToKeyValuePair(payload) };
    case types.SET_SALUTATION_DETAILS:
      return { ...state, salutationDetails: convertSalutationGenderData(payload) };
    case types.SET_MARITAL_STATUS_DETAILS:
      return { ...state, maritalstatusDetails: convertToKeyValuePair(payload) };
    case types.SET_SUB_OCCUPATION_DETAILS:
      return { ...state, subOccupationDetails: convertToKeyValuePair(payload) };
    case types.SET_INSURANCE_COMPANY:
      return { ...state, insuranceCompanyDetails: convertToKeyValuePair(payload) };
    case types.SET_POLICY_STATUS:
      return { ...state, policyStatusDetails: convertToKeyValuePair(payload) };
    case types.SET_RULE_ENGINE: {
      const { productMaster, riderMaster } = payload;
      return {
        ...state,
        ...mapRuleEngineData({
          ...productMaster,
          ...{
            moratoriumPeriod: [
              { label: 0, value: 0 },
              ...populateRange(productMaster?.moratoriumPeriod)
            ],
            moratoriumPeriodWithoutInterest: [
              { label: 0, value: 0 },
              ...populateRange(productMaster?.moratoriumPeriodWithoutInterest)
            ]
          },
          ...{
            term: populateRange(productMaster?.term),
            policyTerm: populateRange(productMaster?.policyTerm)
          }
        }),
        riders: mapRiderMasterData(riderMaster)
      };
    }
    case types.SET_LOAN_VALUES: {
      const { productMaster } = payload;
      return {
        ...state,
        ...mapRuleEngineData({
          ...productMaster,
          ...{
            term: populateRange(productMaster?.term),
            policyTerm: populateRange(productMaster?.policyTerm)
          }
        })
      };
    }
    case types.SET_JOINT_RELATIONSHIP_DETAILS:
      return { ...state, jointRelationshipDetails: convertRelationshipGenderData(payload) };
    case types.SET_PRODUCT:
      return { ...state, product: mapProductData(payload) };
    case types.SET_PRODUCT_PARTNER:
      return { ...state, partnerProduct: mapProductPartnerIdData(payload) };
    case types.SET_CHANNEL:
      return { ...state, channel: convertToKeyValuePair(payload) };
    case types.SET_MEF_JOURNEY_SCHEMA:
      return { ...state, mefJourneySchema: payload };
    case types.SET_QUESTIONNAIRE: {
      return { ...state, questionnaire: mapQuestionnaire(payload) };
    }
    default:
      return state;
  }
};

export { MASTERDATA_REDUCER, mapRuleEngineData };
